import React from 'react';
import _ from 'lodash';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actionCreators from '../../../actions/customer';
import {modal} from '../../../containers/modal';
import moment from 'moment';

import ModalAddGroupProducts from './modals/AddGroupProducts';
import ModalOverlapProduction from './modals/OverlapProduction';
import Form from '../../../components/form/ui-semantic-form';
import FormElement from '../../../components/form/ui-semantic-form-elements';

export class FormCustomer extends React.Component {
	constructor(props) {
		super(props);

		this.avaibleHoursDelivery = [
			{'value':'07:00','label':'07:00'},
			{'value':'07:30','label':'07:30'},
			{'value':'08:00','label':'08:00'},
			{'value':'08:30','label':'08:30'},
			{'value':'09:00','label':'09:00'},
			{'value':'09:30','label':'09:30'},
			{'value':'10:00','label':'10:00'},
			{'value':'10:30','label':'10:30'},
			{'value':'11:00','label':'11:00'},
			{'value':'11:30','label':'11:30'},
			{'value':'12:00','label':'12:00'},
			{'value':'12:30','label':'12:30'},
			{'value':'13:00','label':'13:00'},
			{'value':'13:30','label':'13:30'},
			{'value':'14:00','label':'14:00'},
			{'value':'14:30','label':'14:30'},
			{'value':'15:00','label':'15:00'},
			{'value':'15:30','label':'15:30'},
			{'value':'16:00','label':'16:00'},
			{'value':'16:30','label':'16:30'},
			{'value':'17:00','label':'17:00'},
			{'value':'17:30','label':'17:30'},
			{'value':'18:00','label':'18:00'}
		];

		this.firstIsEmpty = true;

		this.state = {
			isLoading: true,
			isLoadingOverlap: false,
			products: [],
			countProducts: 1,
			sumWeight: 0,
			sumPrice: 0,
			discount_code: false,
			form: false,
			avaibleHoursDelivery: []
		};
	}

	componentDidMount () {
		this.props.actions.fetchProducts().then(function(products){

			if(this.props.fetchModel != undefined)
			{
				this.props.fetchModel().then(function(response){
					let sumWeight = 0,
						sumPrice = 0;

					this.props.model.products.map((product)=>{
						sumWeight += parseFloat(product.weight.replace(',', '.'));
						sumPrice += parseFloat(product.price.replace(',', '.'));
					});

					this.setState({
						isLoading: false,
						products: this.props.model.products,
						countProducts: this.props.model.products.length,
						sumWeight,
						sumPrice,
						avaibleHoursDelivery: this.setAvaibleHoursDelivery(moment(this.props.model.delivery_date).format('YYYY-MM-DD').toString(), this.props.model.delivery_hour)
					});
				}.bind(this));
			}else
				this.setState({
					isLoading: false,
					products: this.props.model.products
				});
		}.bind(this));
	}

	addProduct () {
		let products = this.state.products,
			countProducts = 0;

		products.push({
			product_id: null,
            width: '',
            length: '',
            quantity: 1,
            norm: 0,
						is_lamination: 0,
						lamination_id: '',
            m2: 0,
            weight: 0,
            price: 0,
        });

		this.state.products.map(function(result, index) {
			if(result != undefined)
				countProducts++
		});

        this.setState({
        	products,
        	countProducts
        });
	}

	handleKeyPress (e) {
		if (e.charCode == 13){
			e.preventDefault();
			this.addProduct();
		}
	}

	removeProduct (key) {
		let products = [],
			countProducts = 0,
			sumWeight = 0,
			sumPrice = 0;

		this.state.products.map(function(result, index) {
			if(index != key)
			{
				products[index] = result;
				if(result.weight != undefined)
					sumWeight += parseFloat(result.weight.replace(',', '.'));
				if(result.price != undefined)
					sumPrice += parseFloat(_.isString(result.price) ? result.price.replace(',', '.') : result.price);
				countProducts++;
			}
		});

		this.setState({
			products,
			sumWeight,
			sumPrice,
			countProducts
		});
	}

	changeData(key, models) {
		function truncate (num, places) {
			return Math.trunc(num * Math.pow(10, places)) / Math.pow(10, places);
		}

		let products = this.state.products,
			sumWeight = 0,
			sumPrice = 0,
			laminationCount = models['OrderProduct['+key+'][lamination_id]'] != undefined ? models['OrderProduct['+key+'][lamination_id]'].state.value : 0,
			quantity = 0;

		if((models['OrderProduct['+key+'][width]'].state.value/1000)*(models['OrderProduct['+key+'][length]'].state.value/1000) < 0.5) {
			quantity = 0.5 * models['OrderProduct['+key+'][quantity]'].state.value;
		} else {
			quantity = (models['OrderProduct['+key+'][width]'].state.value/1000)*(models['OrderProduct['+key+'][length]'].state.value/1000) * models['OrderProduct['+key+'][quantity]'].state.value;
		}

		let m2 = parseFloat(quantity);

		products[key].m2 = m2;

		let thickness = 0,
			price = 0;

		this.props.avaibleProducts.map(function(option){
			if(models['OrderProduct['+key+'][product_id]'].state.value == option.value){
				thickness = option.thickness;
				price = _.isString(option.price) ? option.price.replace(',', '.') : option.price;
			}
		});

		products[key].weight = ((2.5 * thickness) * m2).toFixed(2);
		products[key].price = truncate(price * m2, 2);

		if( laminationCount > 0){
			products[key].price = truncate(products[key].price+truncate(_.find(this.props.lamination, {value:laminationCount}).price * m2, 2),2);
		}

		products[key].price = products[key].price;

		products.map(function(result, index) {
			if(result.weight != 0)
				sumWeight += parseFloat(result.weight.replace(',', '.'));

			sumPrice += parseFloat(_.isString(result.price) ? result.price.replace(',', '.') : result.price);
		});

		this.firstIsEmpty = models.length == 0 || (models['OrderProduct[0][width]'].state.value == '' && models['OrderProduct[0][length]'].state.value == '');

		// update statelaminationCount
		this.setState({
			products,
			sumWeight,
			sumPrice,
		});
	}

	changeDataLamination (key, models) 
	{
		let products = this.state.products,
				value = models['OrderProduct['+key+'][is_lamination]'].state.value;

		products[key].is_lamination = value;

		if(!value) {
			products[key].lamination_id = 0;
			models['OrderProduct['+key+'][lamination_id]'].setState({
				value: 0
			});
			models['OrderProduct['+key+'][lamination_id]'].state.value = 0;
			this.changeData(key, models);
		}

		// update state
		this.setState({
			products
		});
	}

	changeDeliveryDateHour (key, models)
	{
		/*
		Pozostałość - sprawdzanie obłożenia produkcji po wybraniu daty i godziny, przeniesione sprawdzanie podczas wysyłki formularza
		let deliveryDate = '';

		if(models['delivery_date'].state.value._isAMomentObject && models['delivery_hour'].state.value != '') {
			this.setState({
				isLoadingOverlap: true
			});
			deliveryDate = models['delivery_date'].state.value.format('YYYY-MM-DD').toString()
			this.props.actions.checkProductionOverlap(deliveryDate, models['delivery_hour'].state.value).then(function(response){
				this.setState({
					isLoadingOverlap: false
				});
			}.bind(this))
		}else{
			this.props.actions.clearProductionOverlap();
		}*/

		if(models['delivery_date'].state.value._isAMomentObject)
			this.setState({
				avaibleHoursDelivery: this.setAvaibleHoursDelivery(models['delivery_date'].state.value.format('YYYY-MM-DD').toString())
			})
	}

	validationProducts (form) {
		if(this.state.countProducts == 0 || this.state.countProducts>100)
			return false;
		else
			return true;
	}

	changeCode (key, models, form) {
        this.setState({
        	discount_code: models.discount_code,
        	form: form
        });
	}

	checkCode () {
		if(this.state.discount_code.state != undefined && this.state.discount_code.state.value != '')
			this.props.actions.activeCode(this.state.discount_code.state.value).then(function(active){
				if(!this.props.model.is_active_code)
					this.state.form.setErrorsOnInputs([{'field':'discount_code','message':'Niepoprawny kod'}]);
			}.bind(this));
	}

	showModalAddGroupProducts () {
		modal.add(ModalAddGroupProducts, {
		 title: 'Dodawanie grupy produktów',
		 size: 'medium',
		 closeOnOutsideClick: false,
		 hideTitleBar: false,
		 hideCloseButton: false,
		 actionAddProducts: this.addGroupProducts.bind(this),
		 avaibleProducts: this.props.avaibleProducts,
		 avaibleLaminations: this.props.lamination
	 });
	}

	addGroupProducts (removeModal, form, count) {
		console.log('form', form.model)
		let products = this.state.products,
			  sumWeight = 0,
			  sumPrice = 0,
				thickness = 0,
				price = 0,
				countNewProducts = 0;

		if(products.length > 0 && this.firstIsEmpty)
		{
			products.shift();
			this.setState({
				products: []
			});
		}

		this.props.avaibleProducts.map(function(option){
			if(form.model.product_id == option.value){
				thickness = option.thickness;
				price = _.isString(option.price) ? option.price.replace(',', '.') : option.price;
			}
		});

		let quantity = 0;

		for(let i = 0; i < count; i++)
		{
			if((form.model['OrderProduct['+i+'][width]']/1000)*(form.model['OrderProduct['+i+'][length]']/1000) < 0.5) {
				quantity = 0.5 * form.model['OrderProduct['+i+'][quantity]'];
			} else {
				quantity = (form.model['OrderProduct['+i+'][width]']/1000)*(form.model['OrderProduct['+i+'][length]']/1000) * form.model['OrderProduct['+i+'][quantity]'];
			}

			let m2 = parseFloat(quantity);

			let product = {
				product_id: form.model.product_id,
				width: form.model['OrderProduct['+i+'][width]'],
				length: form.model['OrderProduct['+i+'][length]'],
				quantity: form.model['OrderProduct['+i+'][quantity]'],
				norm: form.model['OrderProduct['+i+'][norm]'],
				is_lamination: form.model['OrderProduct['+i+'][is_lamination]'],
				lamination_id: form.model['OrderProduct['+i+'][lamination_id]'],
				m2,
				weight: ((2.5 * thickness) * m2).toFixed(2),
				price: (price * m2.toFixed(2)).toFixed(2),
			};
			sumWeight += parseFloat(product.weight);
			sumPrice += parseFloat(product.price);
			products.push(product);
			countNewProducts++;
		}

		removeModal();
		this.firstIsEmpty = false;
		// update state
		this.setState({
			products,
			sumWeight: parseFloat(this.state.sumWeight+sumWeight),
			sumPrice: parseFloat(this.state.sumPrice+sumPrice),
			countProducts: this.state.countProducts+countNewProducts
		});
	}

	setAvaibleHoursDelivery(deliveryDate, existingModelDate = false)
	{
		var isExisting = false;

		let avaibleHoursDelivery = this.avaibleHoursDelivery.filter(function(hour){
			if(moment(deliveryDate+' '+hour.value).format('x') > moment(moment().format('YYYY-MM-DD HH:mm')).format('x')){
				if(existingModelDate != false && existingModelDate == hour.value) {
					isExisting = true;
				}
				return hour;
			}
		});

		if(existingModelDate != false && !isExisting) {
			avaibleHoursDelivery.unshift({'value':existingModelDate,'label':existingModelDate});
		}


		return avaibleHoursDelivery;
	}

	checkProductionOverlap () {
		if(this.state.isLoadingOverlap) {
			return (<div style={{'textAlign' : 'center'}}>
				<span style={{'paddingRight' : '15px', 'fontWeight' : 'bold'}}>Trwa sprawdzanie obciążenia produkcji</span>
				<div className="ui active inline loader"></div>
			</div>)
		}else{
			if(this.props.production_overlap != '') {
				if(this.props.production_overlap <= 30) {
					return null;
				}else if(this.props.production_overlap > 30 && this.props.production_overlap <= 70){
					return (<div className="ui orange message"><i className="info circle icon"></i> Możliwy dłuższy czas oczekiwania - Sugerujemy inną godzinę</div>)
				}else if(this.props.production_overlap > 70)
					return (<div className="ui red message"><i className="warning circle icon"></i> Duże obłożenie produkcji - Wybierz inną godzinę</div>)
			}
		}
	}

	forceSubmit() {
		this.form.model.production_overlap = 'force';
		return this.props.action(this.form)
	}

	onError (response, form) {
		var infoOverlapProduction = '';

		if(Array.isArray(response)) {
			infoOverlapProduction = response.map(error => {
				if(error.field == 'production_overlap') {
					return error.message;
				}
			})
		}

		if(infoOverlapProduction != '') {
			modal.add(ModalOverlapProduction, {
				title: 'Informacja o obłożeniu produkcji',
				size: 'medium',
				closeOnOutsideClick: false,
				hideTitleBar: false,
				hideCloseButton: true,
				content: infoOverlapProduction,
				forceSubmit: this.forceSubmit.bind(this)
			});

			throw new Error('Overlap production');
		}

		return response;
	}

	render () {
			return (
				<div id="form-add-order">
				<Form
					ref={(form) => this.form = form}
					url="customer/order-create"
					loading={this.state.isLoading}
					action={this.props.action}
					onSuccess={this.onSuccess}
					onError={this.onError.bind(this)}
					beforeSend={this.validationProducts.bind(this)}
					buttonSubmitTitle="Wyślij zlecenie">
						<div style={{'width' : '100%', 'display' : 'inline-block', 'clear' : 'both', 'padding' : '10px 0 20px 0'}}>
							<div style={{'width' : '280px', 'float' : 'left', 'paddingTop' : '7px'}}>
								<FormElement
									type="datepicker"
									name="delivery_date"
									title="Planowana data dostawy"
									value={this.props.model.delivery_date}
									validations="isLength:1"
									wprapClass="delivery-date"
									required
									change={this.changeDeliveryDateHour.bind(this)}
									minDate={moment()}
								/>
							</div>
							<div style={{'width' : '200px', 'float' : 'left', 'paddingTop' : '7px'}}>
								<div className="wrap-delivery-hour">
									<FormElement
										type="select"
										name="delivery_hour"
										title="Godzina dostawy"
										options={this.state.avaibleHoursDelivery}
										value={this.props.model.delivery_hour}
										placeholder="wybierz..."
										//validations="isLength:1"
										wprapClass="delivery-hour"
										style={{width : '100px'}}
										required
										change={this.changeDeliveryDateHour.bind(this)}
									/>
								</div>
							</div>
							<div style={{'width' : '380px', 'float' : 'right', 'display' : 'inline-block'}}>
							{ this.checkProductionOverlap() }
							</div>
						</div>
						<br />
						<button type="button" className="ui blue button add-product" onClick={this.addProduct.bind(this)}>
							Dodaj pozycję do zlecenia <i className="add square icon"></i>
						</button>
						<button type="button" className="ui blue button add-product" style={{ 'background' : '#00367c'}} onClick={this.showModalAddGroupProducts.bind(this)}>
							Dodaj kilka pozycji do zlecenia <i className="add square icon"></i>
						</button>
						<div className="wrap-order-products">
							<table className="ui celled table order-products">
								<thead>
									<tr>
										<th className="thickness">Grubość</th>
										<th className="width">Szerokość (mm)</th>
										<th className="length">Długość (mm)</th>
										<th className="count">Ilość</th>
										<th>Waga</th>
										<th>Znaczek</th>
										<th style={{width : '120px'}}>Laminacja</th>
										<th>m<sup>2</sup></th>
										<th>Cena netto</th>
										<th className="center">Usuwanie</th>
									</tr>
								</thead>
								<tbody>
									{
										this.state.products.map(function(result, index) {
											return (
												<tr key={index}>
													<td>
													<FormElement
														type="select"
														name={'OrderProduct['+index+'][product_id]'}
														options={this.props.avaibleProducts}
														value={result.product_id}
														change={this.changeData.bind(this)}
														placeholder="wybierz..."
														validations="isLength:1"
														index={index}
														required
													/>
													</td>
													<td>
													<FormElement
														type="text"
														name={'OrderProduct['+index+'][width]'}
														value={result.width}
														validations="isLength:1"
														change={this.changeData.bind(this)}
														maxlength="4"
														index={index}
														required
													/>
													</td>
													<td>
													<FormElement
														type="text"
														name={'OrderProduct['+index+'][length]'}
														value={result.length}
														validations="isLength:1"
														change={this.changeData.bind(this)}
														maxlength="4"
														index={index}
														required
													/>
													</td>
													<td>
													<FormElement
														type="text"
														name={'OrderProduct['+index+'][quantity]'}
														value={result.quantity}
														validations={"isLength:1,isInt:{'min'-1}"+(result.is_lamination || result.lamination_id > 0 ? ",isInt:{'min'-2},isEven" : '')}
														change={this.changeData.bind(this)}
														index={index}
														keyPress={this.handleKeyPress.bind(this)}
														required
													/>
													<td>
														{result.weight}
													</td>
													</td>
													<td className="norm">
													<FormElement
														type="checkbox"
														name={'OrderProduct['+index+'][norm]'}
														value={result.norm}
														validations="isLength:1"
														required
													/>
													</td>
													<td style={{textAlign : 'center'}}>
															<div style={{float : result.is_lamination || result.lamination_id > 0 ? 'left' : 'none', 'margin' : result.is_lamination || result.lamination_id > 0 ? '6px 0 0 0' : '0px'}}>
																<FormElement
																	type="checkbox"
																	name={'OrderProduct['+index+'][is_lamination]'}
																	value={result.lamination_id > 0 ? 1 : 0}
																	validations="isLength:1"
																	change={this.changeDataLamination.bind(this)}
																	index={index}
																	required
																/>
															</div>
															<div style={{float : 'right'}} className="field-lamination_id">
																{ result.is_lamination || result.lamination_id > 0 ?
																<FormElement
																	type="select"
																	name={'OrderProduct['+index+'][lamination_id]'}
																	options={this.props.lamination}
																	value={result.lamination_id}
																	change={this.changeData.bind(this)}
																	placeholder="folie..."
																	index={index}
																	validations="isLength:1"
																	required
																/>
																: null
																}
															</div>
													</td>
													<td>
														{result.m2.toFixed(2)}
													</td>
													<td>
														{result.price}
													</td>
													<td className="center">
														<i className="remove circle outline icon red" onClick={() => this.removeProduct(index)}></i>
													</td>
												</tr>
											);
										}.bind(this))
									}
								</tbody>
							</table>
						</div>
						<div className="twelve wide column">
							<FormElement
								type="textarea"
								name="comment_client"
								title="Uwagi do zlecenia"
								value={this.props.model.comment_client}
								wprapClass="comment-client"
								rows="2"
							/>
							<fieldset style={{background: '#f9f9f9', padding: '10px 20px 10px 20px', border: '1px solid #aa0000'}}>
								<legend style={{fontSize: '12px', position: 'relative', top: '-1px', fontWeight: 'bold'}}>Ważna informacja</legend>
								<div style={{width: '100%', clear: 'both'}}>
									Glass Technika Sp. z o.o. nie ponosi odpowiedzialności za wykonanie obróbki na szkle powierzonym.<br />
									Wszelkie prace na szkle Klienta są wykonywane na ryzyko zamawiającego
								</div>
							</fieldset>
						</div>
						<div className="summary">
							<div className="summary-item count-products">
								<h2>Ilość pozycji w zamówieniu</h2>
								<div className="ui blue circular label">{this.state.countProducts == 0 ? '0' : this.state.countProducts}</div>
							</div>
							<div className="summary-item wrap-weight">
								<h2>Waga zamówienia</h2>
								<div className="ui blue circular label">{this.state.sumWeight == 0 ? '0' : this.state.sumWeight.toFixed(2)+' kg'}</div>
							</div >
							<div className="summary-item wrap-price">
								<h2>Suma zamówienia</h2>
								<div className="ui blue circular label">{this.state.sumPrice == 0 ? '0' : this.state.sumPrice.toFixed(2)+' zł'}</div>
							</div>
						</div>
						{ this.state.countProducts == 0 ? <div className="ui red pointing label">Proszę dodać jakiś produkt</div> : null }
						{ this.state.countProducts > 100 ? <div className="ui red pointing label">Nie mozna dodać więcej niż 100 produktów</div> : null }
						{ this.props.existDiscountCode  ?
							<div className="wrap-discount-code">
								<div className="input-code">
									<FormElement
										type="text"
										name="discount_code"
										title="Masz kod promocyjny ?"
										placeholder="Wpisz kod rabatowy"
										change={this.changeCode.bind(this)}
										wprapClass="discount-code" />
								</div>
								<div className="button-active">
								{ this.props.model.is_active_code ?
									<div className="ui green button" onClick={this.checkCode.bind(this)}>KOD POPRAWNY</div> :
									<div className="ui red button" onClick={this.checkCode.bind(this)}>AKTYWUJ KOD</div>
								}
								</div>
							</div>
							: null
						}
				</Form>
				</div>
			);
	}
}

const mapStateToProps = (state) => ({
	model: state.order.model,
	avaibleProducts: state.order.avaibleProducts,
	lamination: state.order.lamination,
	existDiscountCode: state.order.exist_discount_code,
	production_overlap: state.customer.production_overlap
});

const mapDispatchToProps = (dispatch) => ({
	actions : bindActionCreators(actionCreators, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(FormCustomer);



/** WEBPACK FOOTER **
 ** ./js/views/customer/order/Form.js
 **/